





































import { defineComponent, reactive, SetupContext, toRef, toRefs, watch, computed, onMounted, onBeforeUnmount } from "@vue/composition-api";
import * as Common from "../commons/common"
import http from "../plugins/http";
import { Menu } from "../modules/Menu";

export interface Data {
  loginId: string
  password: string
  nendo: string
  errors: string[]
}

export default defineComponent({

  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      loginId: "",
      password: "",
      nendo: context.root.$store.getters.getCurrentNendo(),
      errors: new Array<string>()
    });

    /******************************
     * methods
     ******************************/

    // ログインボタン押下
    const onSubmit = async () => {
      state.errors = [];
      if(state.loginId.length == 0){
        state.errors.push("ログインIDを入力してください。");
        return;
      }

      if(state.password.length == 0){
        state.errors.push("パスワードを入力してください。");
        return;
      }

      await http.post(`/api/login`, {condition: {login_id: state.loginId, password: state.password, nendo: state.nendo}}).then(response => {
        if (response.data.confirm == null) {
          executeLogin(response)
        }else {
          if(window.confirm('現在、ログイン中のユーザの処理が中断されます。本当によろしいですか？')){
            http.post("/api/login", {condition: {login_id: state.loginId, password: state.password, nendo: state.nendo}, confirmed: true}).then(response => {
              executeLogin(response)
            })
            .catch(error => {
              if (error.response.status == 401) {
                state.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
              }
              if (error.response.status == 402) {
                state.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
              }
              if (error.response.status == 403) {
                state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
              }
              if (error.response.status == 405) {
                state.errors.push("同時にログインできる人数が上限に達しています。");
              }
              if (error.response.status == 406) {
                state.errors.push("現在メンテナンス中のためログインできません。");
              }
              if (error.response.status == 409) {
                state.errors.push("アカウントが無効になっているためログインできません。");
              }
            })
          }
        }
      })
      .catch(error=>{
        if (error.response.status == 401) {
          state.errors.push("ログインに失敗しました。ユーザIDまたはパスワードを確認してください。");
        }
        if (error.response.status == 402) {
          state.errors.push("IPアドレス制限により、ログインに失敗しました。管理者に問い合わせてください。");
        }
        if (error.response.status == 403) {
          state.errors.push("試行回数の制限を超えました。管理者に問い合わせてください。");
        }
        if (error.response.status == 405) {
          state.errors.push("同時にログインできる人数が上限に達しています。");
        }
        if (error.response.status == 406) {
          state.errors.push("現在メンテナンス中のためログインできません。");
        }
        if (error.response.status == 409) {
          state.errors.push("アカウントが無効になっているためログインできません。");
        }
        if (error.response.status == 410) {
          state.errors.push("生徒アカウントは現在ログインできません。");
        }
      });
    };

    // ログイン成功後の後処理
    const executeLogin = (response: any) => {
      
      // トークン設定
      var token = response.data.user.access_token;
      document.cookie = 'access_token=' + token;

      context.root.$store.commit("setCurrentUser", response.data.user);
      context.root.$store.commit("setCurriculums", response.data.curriculums);
      context.root.$store.commit("setNendos", response.data.nendos);
      context.root.$store.commit("setStudentNum", `${response.data.student_num}`);
      context.root.$store.commit("setGradeId", response.data.grade_id);

      if (context.root.$store.state.currentUser.role == Common.RoleEnum.Student){
        if (response.data.user.to_site_kind == "twenty") {
          context.root.$router.push({path: `/student_site/result_student_twenty`, query: {nendo: state.nendo}}).catch(() => {});
        } else if (response.data.user.to_site_kind == "various") {
          context.root.$router.push({path: `/student_site/result_student_various`, query: {nendo: state.nendo}}).catch(() => {});
        }
      } else {
        context.root.$router.push('/teacher_site/sheet_list').catch(() => {});
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      document.body.style.background = "whitesmoke";
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.background = "white";
    });

    return {
      ...toRefs(state),
      onSubmit
    };
  }
})
